var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show == true)?_c('s-crud',{attrs:{"noBorder":"","noDark":"","searchInput":"","title":"Personas ","filter":_vm.filterGrid,"config":this.config},on:{"doubleClick":function($event){return _vm.doubleClick($event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }